import React from 'react';

const StepForward = () => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 149 256.1"><path d="M166.9,264.5,49.1,380.5a12,12,0,0,1-17,0L25,373.4a12,12,0,0,1,0-17L127.3,256,25.1,155.6a12,12,0,0,1,0-17l7.1-7.1a12,12,0,0,1,17,0L167,247.5A12.1,12.1,0,0,1,166.9,264.5Z" transform="translate(-21.5 -128)"/></svg>
  );
};

export default StepForward;
